const getDefaultState = () => {
	return {
		sidebar: {
			isActive: false,
		},
		selectedUser: null,
		selectedGroup: null,
		selectedProject: null,
	};
};

const Dashboard = {
	namespaced: true,
	state: getDefaultState(),
	mutations: {
		TOGGLE_SIDEBAR: state => {
			state.sidebar.isActive = !state.sidebar.isActive;
		},
		ACTIVATE_SIDEBAR: state => {
			state.sidebar.isActive = true;
		},
		DEACTIVATE_SIDEBAR: state => {
			state.sidebar.isActive = false;
		},
		SELECT_USER: (state, payload) => {
			state.selectedUser = payload;
		},
		SELECT_GROUP: (state, payload) => {
			state.selectedGroup = payload;
		},
		SELECT_PROJECT: (state, payload) => {
			state.selectedProject = payload;
		},
		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},
	},
	actions: {
		toggleSidebar: ({ commit }) => {
			commit("TOGGLE_SIDEBAR");
		},
		activateSidebar: ({ commit, state }) => {
			if (!state.sidebar.isActive) commit("ACTIVATE_SIDEBAR");
		},
		deactivateSidebar: ({ commit, state }) => {
			if (state.sidebar.isActive) commit("DEACTIVATE_SIDEBAR");
		},
		selectUser: ({ commit }, payload) => {
			commit("SELECT_USER", payload);
		},
		selectGroup: ({ commit }, payload) => {
			commit("SELECT_GROUP", payload);
		},
		selectProject: ({ commit }, payload) => {
			commit("SELECT_PROJECT", payload);
		},
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},
	},
	getters: {},
};

export default Dashboard;
